import { themeHelpers } from '@gotamedia/fluffy/theme';
import styled, { css } from 'styled-components';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-jfscpo-0"
})(["margin:auto auto auto 0;flex-grow:1;text-align:right;", ""], themeHelpers.isSmallDevice(css(["margin:auto auto 10px auto;"])));
const Anchor = styled.a.withConfig({
  displayName: "style__Anchor",
  componentId: "sc-jfscpo-1"
})(["margin:auto 0;margin-right:15px;font-size:14px;color:", ";", " &:last-of-type{margin-right:0;}"], ({
  theme
}) => theme.colors.link, themeHelpers.isSmallDevice(css(["margin-right:0;"])));
export { Anchor, Wrapper };